var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { get, filter } from "lodash";
import { getResolvedMessage, injectIntl } from "@irati/utils/lang";
import idHelper from "@irati/utils/id";
import Expander, { ExpanderArrow } from "@irati/ui/src/Expander";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import CheckboxGroup from "./CheckboxGroup";
import { Container, InputWithEllipsis } from "./styled";
var FilterBy = /** @class */ (function (_super) {
    __extends(FilterBy, _super);
    function FilterBy(props) {
        var _this = _super.call(this, props) || this;
        _this.expander = React.createRef();
        _this.handleOutsideClick = function (_a) {
            var _b;
            var target = _a.target;
            if (_this.expander.current) {
                if (!((_b = _this.expander.current.container.current) === null || _b === void 0 ? void 0 : _b.contains(target)) || !_this.expander.current.state.isExpanded) {
                    _this.expander.current.close();
                    return _this.setState({ inFocus: false });
                }
            }
            _this.setState({ inFocus: true });
        };
        _this.getLabel = function () {
            var _a = _this.props, filterOptions = _a.filterOptions, formatMessage = _a.formatMessage, allOptionsSelectedLabel = _a.allOptionsSelectedLabel, multipleOptionsSelectedLabel = _a.multipleOptionsSelectedLabel;
            var totalFilterOptions = filterOptions ? filterOptions.length : 0;
            var checkedFilterOptions = filterOptions ? filterOptions.filter(function (option) { return option.isChecked; }) : [];
            var label;
            if (checkedFilterOptions.length === totalFilterOptions) {
                label = allOptionsSelectedLabel;
            }
            else if (checkedFilterOptions.length === 1) {
                label = _this.labelFromValue(checkedFilterOptions[0].value);
            }
            else {
                label = formatMessage({ id: multipleOptionsSelectedLabel }, { quantity: checkedFilterOptions.length });
            }
            _this.setState({ label: label });
        };
        _this.labelFromValue = function (value) {
            var _a = _this.props, filterOptions = _a.filterOptions, translateLabels = _a.translateLabels;
            var firstOption = filter(filterOptions, function (option) { return option.value === value; })[0];
            if (!translateLabels) {
                return get(firstOption, "name");
            }
            return getResolvedMessage(_this, "name", firstOption);
        };
        _this.updateFilterButtons = function () {
            var _a = _this.props, filterOptions = _a.filterOptions, stopDisablingButtonsOnChange = _a.stopDisablingButtonsOnChange;
            var selectedOptions = filterOptions ? filterOptions.filter(function (option) { return option.isChecked; }) : [];
            var disableResetButton = !filterOptions || !filterOptions.length;
            var disableSaveButton = !selectedOptions.length;
            _this.setState({
                disableResetButton: stopDisablingButtonsOnChange ? false : disableResetButton,
                disableSaveButton: stopDisablingButtonsOnChange ? false : disableSaveButton
            });
        };
        _this.handleSelectFilter = function (event) {
            _this.props.onSelect(event);
            _this.updateFilterButtons();
        };
        _this.handleSelectAllFilters = function (event) {
            _this.props.onSelectAll(event);
            _this.updateFilterButtons();
        };
        _this.handleReset = function () {
            _this.props.onReset();
            _this.setState({
                disableResetButton: true,
                disableSaveButton: true
            });
        };
        _this.handleSave = function () {
            if (_this.expander.current) {
                _this.expander.current.close();
            }
            _this.getLabel();
            _this.props.onFilter();
            _this.setState({
                disableResetButton: true,
                disableSaveButton: true
            });
        };
        _this.state = {
            disableResetButton: !props.stopDisablingButtonsOnChange,
            disableSaveButton: !props.stopDisablingButtonsOnChange,
            label: null,
            inFocus: false
        };
        return _this;
    }
    FilterBy.prototype.UNSAFE_componentWillMount = function () {
        window.addEventListener("click", this.handleOutsideClick);
    };
    FilterBy.prototype.componentDidMount = function () {
        this.getLabel();
    };
    FilterBy.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.filterOptions && this.props.filterOptions) {
            this.getLabel();
        }
    };
    FilterBy.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleOutsideClick);
    };
    FilterBy.prototype.render = function () {
        var _a = this.props, className = _a.className, loadFilterOptions = _a.loadFilterOptions, filterOptions = _a.filterOptions, allOptionText = _a.allOptionText, resetButtonText = _a.resetButtonText, saveButtonText = _a.saveButtonText, id = _a.id, useExpand = _a.useExpand, isAllOptionChecked = _a.isAllOptionChecked, icon = _a.icon;
        var _b = this.state, disableResetButton = _b.disableResetButton, disableSaveButton = _b.disableSaveButton, label = _b.label, inFocus = _b.inFocus;
        var arrow = function (props) { return React.createElement(ExpanderArrow, __assign({}, props)); };
        var header = function () { return (React.createElement(Flex, { alignItems: "center" },
            React.createElement(Icon, { marginLeft: 2, marginRight: 2, size: 16, icon: icon || IconTypes.funnel }),
            React.createElement(InputWithEllipsis, { bold: true }, label))); };
        var checkboxGroup = (React.createElement(CheckboxGroup, { id: idHelper("checkbox-group", this.props), loadFilterOptions: loadFilterOptions, options: filterOptions, allOptionText: allOptionText, onSelect: this.handleSelectFilter, onSelectAll: this.handleSelectAllFilters, resetButtonText: resetButtonText, saveButtonText: saveButtonText, disableResetButton: disableResetButton, disableSaveButton: disableSaveButton, onReset: this.handleReset, onSave: this.handleSave, useExpand: useExpand, isAllOptionChecked: isAllOptionChecked }));
        if (useExpand) {
            return (React.createElement(Container, { id: id, className: className, inFocus: inFocus },
                React.createElement(Expander, { ref: this.expander, fullWidth: true, Header: header, Arrow: arrow }, checkboxGroup)));
        }
        return checkboxGroup;
    };
    FilterBy.defaultProps = {
        small: false,
        className: "",
        withBorder: false,
        translateLabels: true,
        useExpand: true,
        savedFilterOptionsExist: false,
        id: "deals-filter",
        stopDisablingButtonsOnChange: false
    };
    return FilterBy;
}(Component));
export default injectIntl(FilterBy);
